export interface WicketOfferItem {
  id: string;
  name: string;
  item_family_id: string;
  item_id: string;
  description: string;
  status: string;
  external_name: string;
  pricing_model: string;
  price: number;
  period: number;
  currency_code: string;
  period_unit: 'year' | 'month' | 'week';
  free_quantity: number;
  channel: string;
  resource_version: number;
  updated_at: number;
  created_at: number;
  is_taxable: boolean;
  metadata: Record<string, any>;
  item_type: 'plan' | 'charge';
  show_description_in_invoices: boolean;
  show_description_in_quotes: boolean;
  billing_cycles: number | undefined;
}
